export enum DocumentsTypeCodesEnum {
  WEB_0 = 'WEB_0',
  TYPE_LV = 'TYPE_LV',
}
